import logoImg from "../../../assets/images/needle-in-the-haystack-logo.svg";
import whiteLogoImg from "../../../assets/images/needle-in-the-haystack-white-logo.svg";

const Header = ({ isWhite = false, transparent = false }) => {
  return (
    <div className="flex items-center">
      <img
        src={isWhite ? whiteLogoImg : logoImg}
        alt="logo"
        className="
    h-[16px]
    sm:h-[20px]
    md:h-[22px]
    lg:h-[24px]
    w-auto
  "
      />
    </div>
  );
};

export default Header;
